/**
 * Gift card page: type toggle, preview, add to bag (theme afterAddToCart behavior).
 *
 * Cart conflict modal (separate gift-card order + clear cart): set to true to re-enable.
 * Files involved: this file, snippets/gift-card-conflict-modal.liquid,
 * sections/gift-card-page.liquid (render), assets/gift-card-page.css (.gift-card-conflict*),
 * locales/en.default.json + el.json (conflict_* keys under gift_card_page).
 */
(function () {
  var GIFT_CARD_CONFLICT_MODAL_ENABLED = false;
  function cartRoute(name, fallback) {
    if (window.theme && window.theme.routes && window.theme.routes[name]) {
      return window.theme.routes[name];
    }
    return fallback;
  }

  function cartJsUrl() {
    var base = cartRoute('cart', '/cart');
    return base.indexOf('.js') === base.length - 3 ? base : base + '.js';
  }

  function parseJsonEl(id) {
    var el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function trimJoin(first, last) {
    return [first, last].map(function (s) {
      return (s || '').trim();
    }).filter(Boolean).join(' ');
  }

  function formatEurFromCents(cents) {
    var value = Number(cents) / 100;
    return value.toFixed(2);
  }

  var ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
  var SEND_ON_MAX_DAYS = 90;

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function localYmd(date) {
    var d = date || new Date();
    return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate() };
  }

  function toIso(y, m, d) {
    return y + '-' + pad2(m) + '-' + pad2(d);
  }

  function addDaysYmd(ymd, days) {
    return localYmd(new Date(ymd.y, ymd.m - 1, ymd.d + days));
  }

  function parseIsoDate(value) {
    var match = ISO_DATE_RE.exec(value || '');
    if (!match) return null;
    var y = Number(match[1]);
    var m = Number(match[2]);
    var day = Number(match[3]);
    var dt = new Date(y, m - 1, day);
    if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== day) return null;
    return { y: y, m: m, d: day, iso: toIso(y, m, day) };
  }

  function sendOnBounds() {
    var today = localYmd();
    var end = addDaysYmd(today, SEND_ON_MAX_DAYS);
    return { min: toIso(today.y, today.m, today.d), max: toIso(end.y, end.m, end.d) };
  }

  function isSendOnIso(value) {
    var parsed = parseIsoDate(value);
    if (!parsed) return false;
    var bounds = sendOnBounds();
    return parsed.iso >= bounds.min && parsed.iso <= bounds.max;
  }

  function dateFormatter(locale, options) {
    try {
      return new Intl.DateTimeFormat(locale, options);
    } catch (e) {
      return new Intl.DateTimeFormat('en', options);
    }
  }

  function formatLongDate(iso, locale) {
    var parsed = parseIsoDate(iso);
    if (!parsed) return '';
    return dateFormatter(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(
      new Date(parsed.y, parsed.m - 1, parsed.d)
    );
  }

  function GiftCardDatePicker(root) {
    this.root = root;
    this.hidden = root.querySelector('[data-gift-card-delivery-date]');
    this.trigger = root.querySelector('[data-gift-card-date-trigger]');
    this.display = root.querySelector('[data-gift-card-date-display]');
    this.dialog = root.querySelector('[data-gift-card-date-dialog]');
    this.monthEl = root.querySelector('[data-gift-card-date-month]');
    this.weekdaysEl = root.querySelector('[data-gift-card-date-weekdays]');
    this.gridEl = root.querySelector('[data-gift-card-date-grid]');
    this.prevBtn = root.querySelector('[data-gift-card-date-prev]');
    this.nextBtn = root.querySelector('[data-gift-card-date-next]');
    this.clearBtn = root.querySelector('[data-gift-card-date-clear]');
    this.todayBtn = root.querySelector('[data-gift-card-date-today]');
    this.locale = root.dataset.dateLocale || document.documentElement.lang || 'en';
    this.weekStartsOn = root.dataset.dateOrder === 'mdy' ? 0 : 1;
    this.placeholder = root.dataset.placeholder || 'dd/mm/yyyy';
    this.chooseLabel = root.dataset.chooseLabel || '';
    this.view = localYmd();
    this.boundDocPointer = this.handleDocPointer.bind(this);
    this.boundKey = this.handleKey.bind(this);
    this.bind();
    this.renderWeekdays();
    this.syncFromHidden();
  }

  GiftCardDatePicker.prototype.bind = function () {
    var self = this;
    if (this.trigger) {
      this.trigger.addEventListener('click', function () {
        if (self.dialog.hidden) self.open();
        else self.close();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.shiftMonth(-1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.shiftMonth(1);
      });
    }
    if (this.gridEl) {
      this.gridEl.addEventListener('click', function (e) {
        var dayBtn = e.target.closest('[data-iso]');
        if (!dayBtn || dayBtn.disabled) return;
        self.selectIso(dayBtn.getAttribute('data-iso'));
      });
    }
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function () {
        self.clear();
      });
    }
    if (this.todayBtn) {
      this.todayBtn.addEventListener('click', function () {
        self.selectToday();
      });
    }
  };

  GiftCardDatePicker.prototype.isOpen = function () {
    return this.dialog && !this.dialog.hidden;
  };

  GiftCardDatePicker.prototype.open = function () {
    if (!this.dialog) return;
    var selected = parseIsoDate(this.hidden && this.hidden.value);
    this.view = selected ? { y: selected.y, m: selected.m, d: selected.d } : localYmd();
    this.render();
    this.dialog.hidden = false;
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('pointerdown', this.boundDocPointer, true);
    document.addEventListener('keydown', this.boundKey);
    var focusTarget =
      this.gridEl.querySelector('.gift-card-page__date-day.is-selected') ||
      this.gridEl.querySelector('.gift-card-page__date-day.is-today:not(:disabled)') ||
      this.gridEl.querySelector('.gift-card-page__date-day[data-iso]:not(:disabled)');
    if (focusTarget) focusTarget.focus();
  };

  GiftCardDatePicker.prototype.close = function () {
    if (!this.dialog || this.dialog.hidden) return;
    this.dialog.hidden = true;
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', this.boundDocPointer, true);
    document.removeEventListener('keydown', this.boundKey);
  };

  GiftCardDatePicker.prototype.handleDocPointer = function (e) {
    if (!this.root.contains(e.target)) this.close();
  };

  GiftCardDatePicker.prototype.handleKey = function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      if (this.trigger) this.trigger.focus();
      return;
    }
    if (e.key === 'Tab' && this.isOpen()) {
      this.trapFocus(e);
      return;
    }
    if (!this.gridEl.contains(document.activeElement)) return;
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.moveFocus(-1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.moveFocus(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.moveFocus(-7);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.moveFocus(7);
    } else if (e.key === 'PageUp') {
      e.preventDefault();
      this.shiftMonth(-1);
    } else if (e.key === 'PageDown') {
      e.preventDefault();
      this.shiftMonth(1);
    }
  };

  GiftCardDatePicker.prototype.focusable = function () {
    var nodes = [this.prevBtn, this.nextBtn]
      .concat(Array.prototype.slice.call(this.gridEl.querySelectorAll('.gift-card-page__date-day[data-iso]:not(:disabled)')))
      .concat([this.clearBtn, this.todayBtn]);
    return nodes.filter(function (el) {
      return el && !el.disabled && el.offsetParent !== null;
    });
  };

  GiftCardDatePicker.prototype.trapFocus = function (e) {
    var items = this.focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  GiftCardDatePicker.prototype.enabledDays = function () {
    return Array.prototype.slice.call(
      this.gridEl.querySelectorAll('.gift-card-page__date-day[data-iso]:not(:disabled)')
    );
  };

  GiftCardDatePicker.prototype.moveFocus = function (delta) {
    var days = this.enabledDays();
    if (!days.length) return;
    var index = days.indexOf(document.activeElement);
    if (index === -1) index = 0;
    var next = days[index + delta];
    if (next) {
      next.focus();
      return;
    }
    if (delta < 0) this.shiftMonth(-1);
    else this.shiftMonth(1);
  };

  GiftCardDatePicker.prototype.shiftMonth = function (delta) {
    var next = new Date(this.view.y, this.view.m - 1 + delta, 1);
    var viewMonth = toIso(next.getFullYear(), next.getMonth() + 1, 1).slice(0, 7);
    var bounds = sendOnBounds();
    if (viewMonth < bounds.min.slice(0, 7) || viewMonth > bounds.max.slice(0, 7)) return;
    this.view = { y: next.getFullYear(), m: next.getMonth() + 1, d: 1 };
    this.render();
    var focusTarget =
      this.gridEl.querySelector('.gift-card-page__date-day.is-selected') ||
      this.gridEl.querySelector('.gift-card-page__date-day[data-iso]:not(:disabled)');
    if (focusTarget) focusTarget.focus();
  };

  GiftCardDatePicker.prototype.renderWeekdays = function () {
    if (!this.weekdaysEl) return;
    this.weekdaysEl.textContent = '';
    var formatter = dateFormatter(this.locale, { weekday: 'short' });
    var sunday = new Date(2021, 7, 1);
    var i;
    for (i = 0; i < 7; i++) {
      var date = new Date(sunday);
      date.setDate(sunday.getDate() + ((this.weekStartsOn + i) % 7));
      var el = document.createElement('span');
      el.textContent = formatter.format(date);
      this.weekdaysEl.appendChild(el);
    }
  };

  GiftCardDatePicker.prototype.render = function () {
    if (!this.gridEl || !this.monthEl) return;
    var bounds = sendOnBounds();
    var monthFormatter = dateFormatter(this.locale, { month: 'long', year: 'numeric' });
    this.monthEl.textContent = monthFormatter.format(new Date(this.view.y, this.view.m - 1, 1));

    var minMonth = bounds.min.slice(0, 7);
    var maxMonth = bounds.max.slice(0, 7);
    var viewMonth = toIso(this.view.y, this.view.m, 1).slice(0, 7);
    if (this.prevBtn) this.prevBtn.disabled = viewMonth <= minMonth;
    if (this.nextBtn) this.nextBtn.disabled = viewMonth >= maxMonth;

    var firstWeekday = new Date(this.view.y, this.view.m - 1, 1).getDay();
    var leading = (firstWeekday - this.weekStartsOn + 7) % 7;
    var daysInMonth = new Date(this.view.y, this.view.m, 0).getDate();
    var selectedIso = this.hidden && this.hidden.value ? this.hidden.value : '';
    var todayIso = (function () {
      var t = localYmd();
      return toIso(t.y, t.m, t.d);
    })();

    this.gridEl.textContent = '';
    var i;
    for (i = 0; i < leading; i++) {
      var empty = document.createElement('span');
      empty.className = 'gift-card-page__date-day is-empty';
      empty.setAttribute('aria-hidden', 'true');
      this.gridEl.appendChild(empty);
    }

    for (i = 1; i <= daysInMonth; i++) {
      var iso = toIso(this.view.y, this.view.m, i);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gift-card-page__date-day';
      btn.textContent = String(i);
      btn.setAttribute('data-iso', iso);
      btn.setAttribute('role', 'gridcell');
      if (iso === todayIso) btn.classList.add('is-today');
      if (iso === selectedIso) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.setAttribute('aria-selected', 'false');
      }
      if (iso < bounds.min || iso > bounds.max) {
        btn.disabled = true;
      }
      this.gridEl.appendChild(btn);
    }
    this.updateActionState();
  };

  GiftCardDatePicker.prototype.selectToday = function () {
    var today = localYmd();
    this.selectIso(toIso(today.y, today.m, today.d));
  };

  GiftCardDatePicker.prototype.clear = function () {
    if (this.hidden) this.hidden.value = '';
    this.updateDisplay();
    this.updateActionState();
    this.close();
    if (this.trigger) this.trigger.focus();
  };

  GiftCardDatePicker.prototype.updateActionState = function () {
    if (this.clearBtn) this.clearBtn.disabled = !isSendOnIso(this.hidden && this.hidden.value);
  };

  GiftCardDatePicker.prototype.selectIso = function (iso) {
    if (!isSendOnIso(iso) || !this.hidden) return;
    this.hidden.value = iso;
    this.updateDisplay();
    var error = this.root.parentNode && this.root.parentNode.querySelector('[data-gift-card-date-error]');
    if (error) error.hidden = true;
    this.close();
    if (this.trigger) this.trigger.focus();
  };

  GiftCardDatePicker.prototype.syncFromHidden = function () {
    if (!isSendOnIso(this.hidden && this.hidden.value)) {
      if (this.hidden) this.hidden.value = '';
    }
    this.updateDisplay();
  };

  GiftCardDatePicker.prototype.updateDisplay = function () {
    var iso = this.hidden && this.hidden.value;
    var valid = isSendOnIso(iso);
    var label = valid ? formatLongDate(iso, this.locale) : this.placeholder;
    if (this.display) {
      this.display.textContent = label;
      this.display.classList.toggle('is-placeholder', !valid);
    }
    if (this.trigger) {
      this.trigger.setAttribute('aria-label', valid && this.chooseLabel ? this.chooseLabel + ', ' + label : this.chooseLabel || label);
    }
    this.updateActionState();
  };

  function GiftCardPage(root) {
    this.root = root;
    this.config = parseJsonEl('gift-card-config');
    this.pillsData = parseJsonEl('gift-card-pills-data');
    this.cvAmount = document.getElementById('gift-card-cv-amount');
    this.modeDesc = document.getElementById('gift-card-mode-description');
    this.pillsEl = document.getElementById('gift-card-pills');
    this.modal = document.getElementById('gift-card-conflict-modal');
    this.pendingCheckout = null;
    this.productIdSet = new Set((this.config.productIds || []).map(Number).filter(Boolean));
  }

  GiftCardPage.prototype.init = function () {
    var self = this;
    this.root.querySelectorAll('.gift-card-page__form-panel').forEach(function (panel) {
      self.bindForm(panel);
    });
    this.root.querySelectorAll('[data-gift-card-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setMode(btn.dataset.giftCardMode);
      });
    });
    if (GIFT_CARD_CONFLICT_MODAL_ENABLED) {
      this.bindModal();
    }
    var defaultMode = this.root.dataset.defaultMode || 'digital';
    if (document.getElementById('gift-card-panel-' + defaultMode)) {
      this.setMode(defaultMode);
    } else {
      this.setMode('digital');
    }
  };

  GiftCardPage.prototype.updateCardAmount = function (radio) {
    if (this.cvAmount && radio && radio.dataset.money) {
      this.cvAmount.textContent = radio.dataset.money;
    }
  };

  GiftCardPage.prototype.updateMessageNote = function (mode) {
    var panel = this.getActivePanel();
    if (!panel) return;
    var note = panel.querySelector('[data-gift-card-message-note]');
    if (!note) return;
    if (mode === 'physical' && this.config.messageNotePhysical) {
      note.textContent = this.config.messageNotePhysical;
    } else if (this.config.messageNoteDigital) {
      note.textContent = this.config.messageNoteDigital;
    }
  };

  GiftCardPage.prototype.pillIcons = {
    email: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>',
    shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
    truck: '<rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>',
    clock: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
    box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 2 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>'
  };

  GiftCardPage.prototype.renderPills = function (mode) {
    if (!this.pillsEl) return;
    var items = this.pillsData[mode] || this.pillsData.digital || [];
    var icons = this.pillIcons;
    this.pillsEl.innerHTML = items
      .map(function (item) {
        var paths = icons[item.icon] || icons.email;
        return (
          '<span class="gift-card-page__pill"><svg viewBox="0 0 24 24" aria-hidden="true">' +
          paths +
          '</svg>' +
          item.text +
          '</span>'
        );
      })
      .join('');
  };

  GiftCardPage.prototype.getActivePanel = function () {
    return this.root.querySelector('.gift-card-page__form-panel:not([hidden])');
  };

  GiftCardPage.prototype.getActiveForm = function () {
    var panel = this.getActivePanel();
    return panel ? panel.querySelector('[data-gift-card-form]') : null;
  };

  GiftCardPage.prototype.setMode = function (mode) {
    var self = this;
    this.root.dataset.activeMode = mode;
    this.root.querySelectorAll('[data-gift-card-panel]').forEach(function (panel) {
      var isActive = panel.dataset.giftCardPanel === mode;
      panel.hidden = !isActive;
      if (isActive) {
        var checked = panel.querySelector('input[type="radio"][data-variant-id]:checked');
        if (checked) self.updateCardAmount(checked);
      }
    });
    this.root.querySelectorAll('[data-gift-card-mode]').forEach(function (btn) {
      var active = btn.dataset.giftCardMode === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (this.modeDesc) {
      this.modeDesc.hidden = mode !== 'digital';
    }
    this.renderPills(mode);
    this.updateMessageNote(mode);
  };

  GiftCardPage.prototype.bindForm = function (panel) {
    var self = this;
    var form = panel.querySelector('[data-gift-card-form]');
    if (!form || form.dataset.giftCardBound) return;
    form.dataset.giftCardBound = 'true';

    form.querySelectorAll('input[type="radio"][data-variant-id]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (panel === self.getActivePanel()) self.updateCardAmount(radio);
      });
    });

    var scheduleToggle = form.querySelector('[data-gift-card-schedule-toggle]');
    var scheduleRow = form.querySelector('.gift-card-page__schedule-date');
    var datePickerRoot = form.querySelector('[data-gift-card-date-picker]');
    var datePicker = datePickerRoot ? new GiftCardDatePicker(datePickerRoot) : null;
    if (scheduleToggle && scheduleRow) {
      scheduleToggle.addEventListener('change', function () {
        scheduleRow.hidden = !scheduleToggle.checked;
        if (!scheduleToggle.checked) {
          if (datePicker) datePicker.close();
          var dateErr = form.querySelector('[data-gift-card-date-error]');
          if (dateErr) dateErr.hidden = true;
        }
      });
    }

    var emailField = form.querySelector('[data-gift-card-email]');
    var emailConfirm = form.querySelector('[data-gift-card-email-confirm]');
    var emailError = form.querySelector('[id^="gift-card-email-error"]');

    if (emailField && emailConfirm && emailError) {
      emailConfirm.addEventListener('input', function () {
        if (emailField.value === emailConfirm.value) emailError.hidden = true;
      });
    }

    var proceedBtn = form.querySelector('[data-gift-card-proceed]');
    if (proceedBtn) {
      proceedBtn.addEventListener('click', function () {
        self.handleProceed(form);
      });
    }
  };

  GiftCardPage.prototype.validateForm = function (form) {
    var emailField = form.querySelector('[data-gift-card-email]');
    var emailConfirm = form.querySelector('[data-gift-card-email-confirm]');
    var emailError = form.querySelector('[id^="gift-card-email-error"]');

    if (emailField && emailConfirm) {
      if (emailField.value.trim() !== emailConfirm.value.trim()) {
        if (emailError) emailError.hidden = false;
        emailConfirm.focus();
        return false;
      }
      if (emailError) emailError.hidden = true;
    }

    var scheduleToggle = form.querySelector('[data-gift-card-schedule-toggle]');
    if (scheduleToggle && scheduleToggle.checked) {
      var deliveryDateInput = form.querySelector('[data-gift-card-delivery-date]');
      var dateErr = form.querySelector('[data-gift-card-date-error]');
      if (!isSendOnIso(deliveryDateInput && deliveryDateInput.value)) {
        if (dateErr) dateErr.hidden = false;
        var trigger = form.querySelector('[data-gift-card-date-trigger]');
        if (trigger) trigger.focus();
        return false;
      }
      if (dateErr) dateErr.hidden = true;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }

    return true;
  };

  GiftCardPage.prototype.collectPayload = function (form) {
    var cardType = form.dataset.cardType;
    var isDigital = cardType === 'Digital';
    var radio = form.querySelector('input[type="radio"][data-variant-id]:checked');
    var scheduleToggle = form.querySelector('[data-gift-card-schedule-toggle]');
    var deliveryDateInput = form.querySelector('[data-gift-card-delivery-date]');
    var message = (form.querySelector('[data-gift-card-message]') || {}).value || '';

    var fromFirst = (form.querySelector('[data-gift-card-from-first]') || {}).value || '';
    var fromLast = (form.querySelector('[data-gift-card-from-last]') || {}).value || '';
    var toFirst = (form.querySelector('[data-gift-card-to-first]') || {}).value || '';
    var toLast = (form.querySelector('[data-gift-card-to-last]') || {}).value || '';
    var recipientEmail = (form.querySelector('[data-gift-card-email]') || {}).value || '';

    var deliveryDate = 'immediate';
    if (isDigital && scheduleToggle && scheduleToggle.checked && isSendOnIso(deliveryDateInput && deliveryDateInput.value)) {
      deliveryDate = deliveryDateInput.value;
    }

    var priceCents = radio ? radio.dataset.priceCents : '';

    return {
      mode: isDigital ? 'digital' : 'physical',
      cardType: cardType,
      variantId: radio ? Number(radio.dataset.variantId) : null,
      amountEur: formatEurFromCents(priceCents),
      fromName: trimJoin(fromFirst, fromLast),
      toName: trimJoin(toFirst, toLast),
      senderFirstName: fromFirst.trim(),
      senderLastName: fromLast.trim(),
      recipientFirstName: toFirst.trim(),
      recipientLastName: toLast.trim(),
      recipientEmail: recipientEmail.trim(),
      message: message.trim(),
      deliveryDate: deliveryDate,
      isNativeGiftCard: isDigital && !!this.config.nativeGiftCardDigital
    };
  };

  GiftCardPage.prototype.buildLineProperties = function (payload) {
    var props = {
      _from_name: payload.fromName,
      _to_name: payload.toName,
      _message: payload.message || '',
      _type: payload.cardType,
      _amount: payload.amountEur
    };

    if (payload.mode === 'digital') {
      props._recipient_email = payload.recipientEmail;
      props._delivery_date = payload.deliveryDate;

      /* Shopify gift card recipient API (https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards).
         Underscore props above are for admin/ops only; scheduling + email use the names below. */
      if (payload.recipientEmail) {
        props['Recipient email'] = payload.recipientEmail;
        props['__shopify_send_gift_card_to_recipient'] = 'true';
        props['__shopify_offset'] = String(new Date().getTimezoneOffset());
      }
      if (payload.toName) {
        props['Recipient name'] = payload.toName;
      }
      if (payload.message) {
        props['Message'] = payload.message;
      }
      if (payload.deliveryDate && payload.deliveryDate !== 'immediate') {
        props['Send on'] = payload.deliveryDate;
      }
    }

    return props;
  };

  GiftCardPage.prototype.isGiftCardLine = function (item) {
    if (this.productIdSet.has(Number(item.product_id))) return true;
    if (item.product_type === 'Gift Card') return true;
    if (item.properties && (item.properties._type === 'Digital' || item.properties._type === 'Physical')) {
      return true;
    }
    return false;
  };

  GiftCardPage.prototype.cartHasOtherItems = function (cart) {
    return (cart.items || []).some(
      function (item) {
        return !this.isGiftCardLine(item);
      }.bind(this)
    );
  };

  GiftCardPage.prototype.handleProceed = function (form) {
    var self = this;
    if (!this.validateForm(form)) return;

    var payload = this.collectPayload(form);
    if (!payload.variantId) return;

    this.setCheckoutError(form, '');

    if (!GIFT_CARD_CONFLICT_MODAL_ENABLED) {
      self
        .submitGiftCardToBag(payload, false)
        .catch(function () {
          self.setCheckoutError(form, self.config.errorGeneric || 'Something went wrong. Please try again.');
        });
      return;
    }

    /* Conflict modal flow — re-enable GIFT_CARD_CONFLICT_MODAL_ENABLED above */
    this.setProceedLoading(form, true);

    fetch(cartJsUrl())
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (self.cartHasOtherItems(cart)) {
          self.pendingCheckout = { payload: payload, clearCartFirst: true };
          self.openModal();
        } else {
          return self.submitGiftCardToBag(payload, false);
        }
      })
      .catch(function () {
        self.setCheckoutError(form, self.config.errorGeneric || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        self.setProceedLoading(form, false);
      });
  };

  GiftCardPage.prototype.handleAfterAddToCart = function (data, triggerBtn) {
    var themeRef = window.theme;

    if (themeRef && themeRef.setCartLastAddedProductId && data.product_id) {
      themeRef.setCartLastAddedProductId(data.product_id);
    }

    if (document.querySelector('.template-cart')) {
      var cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.enableAjaxUpdate) {
        cartForm.refresh();
      }
      return;
    }

    if (themeRef && themeRef.settings && themeRef.settings.afterAddToCart === 'page') {
      setTimeout(function () {
        window.location.href = cartRoute('cart', '/cart');
      }, 300);
      return;
    }

    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));

    if (themeRef && themeRef.settings) {
      if (themeRef.settings.afterAddToCart === 'notification') {
        var template = document.getElementById('AddedNotification');
        if (template && template.content) {
          var notification = template.content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data.product_title || '';
          var container = document.querySelector('.pageheader--sticky') || document.body;
          container.appendChild(notification);
        }
      } else if (themeRef.settings.afterAddToCart === 'drawer') {
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(triggerBtn);
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: data.variant_id,
          productId: data.product_id
        }
      })
    );
  };

  GiftCardPage.prototype.submitGiftCardToBag = function (payload, clearCartFirst) {
    var self = this;
    var form = this.getActiveForm();
    var triggerBtn = form ? form.querySelector('[data-gift-card-proceed]') : null;

    this.setProceedLoading(form, true);

    var chain = Promise.resolve();
    if (clearCartFirst) {
      chain = chain.then(function () {
        return fetch('/cart/clear.js', { method: 'POST' });
      });
    }

    return chain
      .then(function () {
        return fetch(cartRoute('cartAdd', '/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: payload.variantId,
                quantity: 1,
                properties: self.buildLineProperties(payload)
              }
            ]
          })
        });
      })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        self.handleAfterAddToCart(data, triggerBtn);
      })
      .catch(function (err) {
        var msg =
          (err && err.description) ||
          (err && err.message) ||
          self.config.errorGeneric ||
          'Could not add gift card to bag. Please try again.';
        self.setCheckoutError(form, msg);
      })
      .finally(function () {
        self.setProceedLoading(form, false);
      });
  };

  /* Proceed-to-checkout with URL prefill — kept for reference if client wants it later
  GiftCardPage.prototype.buildCheckoutUrl = function (payload) {
    var base = this.config.checkoutUrl || '/checkout';
    var params = new URLSearchParams();
    if (payload.mode === 'digital') {
      if (payload.recipientEmail) params.set('checkout[email]', payload.recipientEmail);
      if (payload.senderFirstName) {
        params.set('checkout[shipping_address][first_name]', payload.senderFirstName);
      }
      if (payload.senderLastName) {
        params.set('checkout[shipping_address][last_name]', payload.senderLastName);
      }
    } else {
      if (payload.recipientFirstName) {
        params.set('checkout[shipping_address][first_name]', payload.recipientFirstName);
      }
      if (payload.recipientLastName) {
        params.set('checkout[shipping_address][last_name]', payload.recipientLastName);
      }
    }
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  };
  */

  GiftCardPage.prototype.setCheckoutError = function (form, message) {
    if (!form) return;
    var el = form.querySelector('[data-gift-card-checkout-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  };

  GiftCardPage.prototype.setProceedLoading = function (form, loading) {
    if (!form) return;
    var btn = form.querySelector('[data-gift-card-proceed]');
    if (!btn) return;
    btn.disabled = loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  GiftCardPage.prototype.openModal = function () {
    if (!this.modal) return;
    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gift-card-conflict-open');
    var primary = this.modal.querySelector('[data-gift-card-conflict-proceed]');
    if (primary) primary.focus();
  };

  GiftCardPage.prototype.closeModal = function () {
    if (!this.modal) return;
    this.modal.hidden = true;
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gift-card-conflict-open');
    this.pendingCheckout = null;
  };

  GiftCardPage.prototype.bindModal = function () {
    var self = this;
    if (!this.modal) return;

    this.modal.querySelectorAll('[data-gift-card-conflict-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.closeModal();
      });
    });

    var proceed = this.modal.querySelector('[data-gift-card-conflict-proceed]');
    if (proceed) {
      proceed.addEventListener('click', function () {
        if (!self.pendingCheckout) {
          self.closeModal();
          return;
        }
        var pending = self.pendingCheckout;
        self.closeModal();
        self.submitGiftCardToBag(pending.payload, pending.clearCartFirst);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal && !self.modal.hidden) {
        self.closeModal();
      }
    });
  };

  var SWYM_ATW_SEL = [
    '#swym-atw-button-container',
    '.swym-atw-button-container',
    '.swym-button-content',
    '.swym-custom-pdp-button',
    '.swym-button-bar',
    '.swym-wishlist-button-bar',
    '.swym-inject',
    '[data-swaction="addToWishlist"]',
    '[data-swaction="addToWishList"]',
    'button.swym-icon-text',
    '[class*="swym-add-to-wishlist"]',
    '[class*="swym-custom-pdp"]'
  ].join(', ');

  function hideSwymAtw(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll(SWYM_ATW_SEL).forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function watchSwymAtw(root) {
    var scope = document.querySelector('.section-gift-card-form') || root;
    hideSwymAtw(scope);

    var attempts = 0;
    var timer = setInterval(function () {
      hideSwymAtw(scope);
      attempts += 1;
      if (attempts >= 24) clearInterval(timer);
    }, 250);

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        hideSwymAtw(scope);
      }).observe(scope, { childList: true, subtree: true });
    }
  }

  function boot() {
    var root = document.getElementById('gift-card-page');
    if (!root) return;
    watchSwymAtw(root);
    new GiftCardPage(root).init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
